import { SxProps } from '@mui/material'
import { WHITE_BAR_HEIGHT } from '../Banner.style'

interface BannerPoweredByStyles {
  poweredBy: SxProps
  poweredByInline: SxProps
  poweredByLabel: SxProps
  poweredByLogo: SxProps
}

export const bannerPoweredByStyles: BannerPoweredByStyles = {
  poweredBy: {
    position: 'absolute',
    bottom: { xs: WHITE_BAR_HEIGHT.MOBILE + 100, lg: WHITE_BAR_HEIGHT.DESKTOP + 100 },
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.75,
    whiteSpace: 'nowrap',
    '@media (orientation: landscape) and (max-height: 700px)': {
      display: 'none',
    },
    '@media (max-height: 900px)': {
      bottom: { xs: WHITE_BAR_HEIGHT.MOBILE + 100, lg: WHITE_BAR_HEIGHT.DESKTOP + 50 },
    },
    '@media (max-height: 800px)': {
      bottom: { xs: WHITE_BAR_HEIGHT.MOBILE + 100, lg: WHITE_BAR_HEIGHT.DESKTOP + 30 },
    },
  },
  poweredByInline: {
    display: 'none',
    '@media (orientation: landscape) and (max-height: 700px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0.75,
      whiteSpace: 'nowrap',
      mt: 2,
      mb: `${WHITE_BAR_HEIGHT.MOBILE + 8}px`,
    },
  },
  poweredByLabel: {
    typography: 'textXs',
    color: 'pageTheme.textColor',
    opacity: 0.55,
  },
  poweredByLogo: {
    height: { xs: 18, lg: 22 },
    width: 'auto',
    color: 'pageTheme.textColor',
    display: 'block',
  },
}
